import React from 'react';
import { Box, Button, TextSmall } from '@teamleader/ui';
import { translate } from '@teamleader/i18n';
import useQuery from '../../Infrastructure/Routing/useQuery';

import styles from './styles.css';
import GoogleIcon from './icons/google.svg';

const LoginWithIdentityProvider = ({
  handleLoginWithIdentityProvider,
}: {
  handleLoginWithIdentityProvider: (identityProvider: string) => void;
}) => {
  const queryParams = useQuery();

  const createRedirectUrlForIdentityProvider = (identityProvider: string): string => {
    const redirectUrlForIdentityProvider = __CONFIG__.apiUrl + '/identityProviders/' + identityProvider + '/login';

    const hasQueryParams = queryParams.toString().length > 0;
    if (hasQueryParams) {
      queryParams.delete('prompt');
      queryParams.delete('error');

      return redirectUrlForIdentityProvider + '?' + queryParams.toString();
    }

    return redirectUrlForIdentityProvider;
  };

  return (
    <Box marginTop={4} marginBottom={3}>
      <Button
        size="large"
        level="secondary"
        fullWidth
        icon={<GoogleIcon />}
        element="a"
        href={createRedirectUrlForIdentityProvider('google')}
        onClick={() => handleLoginWithIdentityProvider('google')}
        marginBottom={3}
      >
        Google
      </Button>
      <Box display="flex">
        <TextSmall className={styles['or-login-with-divider']}>{translate('orLoginWith')}</TextSmall>
      </Box>
    </Box>
  );
};

export default LoginWithIdentityProvider;
